    import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {AutoVisitList, AutoVisitListProps} from "~/apps/packages/auto-visits/components/AutoVisitList/AutoVisitList";
import {Box, Container, Grid, IconButton, Button} from "@mui/material";
import {AddCircle, ArrowBack} from "@mui/icons-material";
import {useHistory} from "react-router-dom";
import {SearchAppBar} from "~/apps/core/ui/SearchAppBar";
import {useCurrentCarrierId} from "~/apps/packages/auto-visits/hooks";
import {
    AutoVisitStatusChipInput,
    AutoVisitStatusChipInputProps
} from "~/apps/packages/auto-visits/components/AutoVisitStatusChipInput";
import {DateRangeChipInput, DateRangeChipInputProps} from "~/apps/packages/auto-visits/components/DateRangeChipInput";
import {AutoVisitStatusV2} from "~/apps/packages/auto-visits/queries";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {useHistoryState} from "~/apps/core/utils";
import moment from "moment";
import {tuple} from "~/types";
import {FiltersBar} from "~/apps/core/ui/FiltersBar";
    import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";
    import {useChangeEffect} from "~/lib/useChangeEffect";
    import {LoadingBox} from "~/apps/core/ui/LoadingBox";


type FilterState = {
    statuses?: AutoVisitStatusV2[]
    search?: string
    dateRange?: [Date, Date]
}


function useFilterState() {
    const [value, setValue, delValue] = useHistoryState<any>({
        name: "filter",
        serialize: state => JSON.stringify(state),
        deserialize: value => JSON.parse(value),
        handleBack: false,
    });

    const filter = useMemo(() => {
        const filter: FilterState = {};
        if (typeof value?.search == "string" && value.search.length > 0) {
            filter.search = value.search;
        }
        if (Array.isArray(value?.statuses) && value.statuses.filter(s => typeof s != "string").length == 0){
            if (value.statuses.length > 0) {
                filter.statuses = value.statuses;
            }
        }
        if (Array.isArray(value?.dateRange) && value.dateRange.length == 2) {
            const dateRange = value.dateRange.map(x => moment(x));
            if (dateRange.filter(x => x.isValid()).length == 2) {
                filter.dateRange = dateRange.map(x => x.toDate());
            }
        }

        return filter;
    }, [value]);

    const setFilter = useCallback(async value => {
        if (value) {
            value = {...value};
            if (!value.search) {
                delete value.search;
            }
            if (!value.statuses || value.statuses.length == 0) {
                delete value.statuses;
            }
            if (!value.dateRange){
                delete value.dateRange;
            }
            if (Object.keys(value).length > 0) {
                await setValue(value);
                return;
            }
        }
        await delValue();
    }, []);

    return tuple(filter, setFilter);
}


export const IndexPage = () => {
    const $container = useRef<HTMLDivElement>();
    const history = useHistory();
    const [carrierId] = useCurrentCarrierId();
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useFilterState();
    const canFilter = !loading;
    const title = filter.search || "Автовизиты";

    useEffect(() => {
        /// грязный хак для выставления дефолтного состояния фильтров. Если мы не вернулись назад то state == true
        if (!history.location.state) {
            history.replace({
                ...history.location,
                state: true,
            });
            setFilter({
                dateRange: [moment().add(-1, "days").toDate(), moment().add(3, "days").toDate()]
            }).then(() => null);
        }
    }, []);

    useChangeEffect(() => {
        $container.current?.scrollTo(0, 0);
    }, [filter])

    const handleCreateClick = () => {
        history.push("/new");
    }

    const handleSearchQueryChange = (query: string) => {
        setFilter({
            ...filter,
            search: query
        }).then(() => null);
    }

    const handleLoading = (loading) => {
        setLoading(loading);
    }

    const handleListChange: AutoVisitListProps["onChange"] = (data) => {
    }

    const handleStatusesChange: AutoVisitStatusChipInputProps["onChange"] = (value) => {
        setFilter({
            ...filter,
            statuses: value,
        }).then(() => null);
    }

    const handleDateRangeChange: DateRangeChipInputProps["onChange"] = (value) => {
        setFilter({
            ...filter,
            dateRange: value,
        }).then(() => null);
    }

    return <>
        <SearchAppBar
            position="fixed"
            color="default"
            title={title}
            disabled={!canFilter}
            onSearch={handleSearchQueryChange}
            query={filter.search}
        >
            <FiltersBar>
                <DateRangeChipInput
                    onChange={handleDateRangeChange}
                    value={filter.dateRange}
                    disabled={loading}
                />
                <AutoVisitStatusChipInput onChange={handleStatusesChange} value={filter.statuses} disabled={loading}/>
            </FiltersBar>
        </SearchAppBar>

        <AbsoluteContainer disableGutters top={104} ref={$container}>
            <AutoVisitList
                onLoading={handleLoading}
                onChange={handleListChange}
                statuses={filter.statuses}
                dateFrom={filter?.dateRange ? filter.dateRange[0] : null}
                dateTo={filter?.dateRange ? filter.dateRange[1] : null}
                query={filter.search}
                carrierId={carrierId}
            />
            <Box minHeight="80px"/>
        </AbsoluteContainer>
        <FloatingActions>
            <Button fullWidth onClick={handleCreateClick} color="primary" startIcon={<AddCircle/>}>
                Создать автовизит
            </Button>
        </FloatingActions>
    </>;
}